var generic = generic || {};
var site = site || {};
var Drupal = Drupal || {};
var settings = Drupal.settings || {};
var FB = window.FB;

(function(d, s, id) {
  if (!settings.fb_share_sdk_locale) {
    return false;
  }
  var js, fjs = d.getElementsByTagName(s)[0];
  var locale = settings.fb_share_sdk_locale || 'fr_FR';
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s); js.id = id;
  js.src = '//connect.facebook.net/' + locale + '/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk')
);

(function($) {
  site.facebookShare = (function() {
    if (!settings.fb_share_app_id) {
      return false;
    }
    var _initFB = function() {
      FB.init({
        appId: settings.fb_share_app_id,
        cookie: true,
        xfbml: true,
        version: 'v14.0'
      });
    };

    return {
      init: function() {
        try {
          _initFB();
        } catch (e) {
          console.log(e);
        }
      },
    };
  }());

  window.fbAsyncInit = function() {
    try {
      site.facebookShare.init();
    } catch (e) {
      console.log(e);
    }
  };
})(jQuery);
